import React from 'react';
import BaseNode from './BaseBlockNode';
import { buildSourceInfoMarkers, renderValue } from '../../helpers/node';
import { PARAMS_LABEL } from '../../../constants';

function RenewableNode(props) {
  const {
    withHardConstraint,
    withMeasurementPoint,
    maxLoad,
    nominalVoltage,
    presentLoad,
  } = props;

  return (
    <BaseNode
      {...props}
      phases={null}
      infoMarkers={
        buildSourceInfoMarkers({ withHardConstraint, withMeasurementPoint })
      }
      staticParams={[
        { label: 'Max Load', value: renderValue(maxLoad, 'A') },
        { label: 'Nominal Voltage', value: renderValue(nominalVoltage, 'V') },
      ]}
      dynamicParams={[
        { label: PARAMS_LABEL.presentLoad, value: renderValue(presentLoad, 'A') },
      ]}
    />
  );
}

export default RenewableNode;
